import { ConfigError } from "./errors";

/**
 * The Vite `--mode` IS the environment. Pure module: no `import.meta`, no
 * `process`, so Next.js and Node (vite config) can import it too.
 */
export const APP_ENVIRONMENTS = [
  "development",
  "local-docker",
  "test",
  "staging",
  "production",
] as const;

export type AppEnvironment = (typeof APP_ENVIRONMENTS)[number];

export const DEPLOYED_ENVIRONMENTS: readonly AppEnvironment[] = [
  "test",
  "staging",
  "production",
];

export const isAppEnvironment = (value: unknown): value is AppEnvironment =>
  typeof value === "string" &&
  (APP_ENVIRONMENTS as readonly string[]).includes(value);

/**
 * Websites select the environment with `NEXT_PUBLIC_ENV` (Next's own prefix).
 * Unset keeps today's `local-docker` fallback; anything else must be a known
 * environment.
 */
export const resolveWebsiteEnvironment = (
  raw: string | undefined,
): AppEnvironment => {
  if (raw === undefined || raw === "") return "local-docker";
  if (!isAppEnvironment(raw)) {
    throw new ConfigError(
      "CONFIG_UNKNOWN_ENVIRONMENT",
      `NEXT_PUBLIC_ENV "${raw}" is not one of: ${APP_ENVIRONMENTS.join(", ")}`,
    );
  }
  return raw;
};
